module.exports = __webpack_public_path__ + "bi.svg?5baaa143add7879a25b24d07038bd796";